import React from "react";
import { useEnterpriseStructure } from "../../Hooks/useEnterpriseStructure";
import styles from "./profileManaging.module.css";

const TreeBranch = ({ nodes }) => {
  if (!nodes.length) {
    return null;
  }

  return (
    <ul className={styles.treeList}>
      {nodes.map((node) => (
        <li
          key={`${node.type}_${node.id}`}
          className={styles.treeItem}
        >
          <span className={styles.treeName}>{node.name}</span>
          {node.children.length > 0 && (
            <TreeBranch nodes={node.children} />
          )}
        </li>
      ))}
    </ul>
  );
};

const ManagingStructureTree = () => {
  const { tree } = useEnterpriseStructure();

  if (!tree) {
    return null;
  }

  return (
    <div className={styles.structureTreeRow}>
      <div className={styles.structureTreeSpacer} aria-hidden="true" />
      <div className={styles.structureTree}>
        <div className={styles.treeRoot}>{tree.name}</div>
        <TreeBranch nodes={tree.children} />
      </div>
    </div>
  );
};

export default ManagingStructureTree;
